import React, { useState, useEffect } from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import { Link } from 'react-router-dom';
import { resetPassword } from '../../API';
import { config } from '../../config';

import lightVars from '../../light.json';
import darkVars from '../../dark.json';
import './ResetPassword.less';

// ICONS
import logoLight from '../../icons/parity-logo-light.svg';
import logoDark from '../../icons/parity-logo-dark.svg';

// IMAGES
import resetSuccess from '../../images/adding-buildings.png';

const { REACT_APP_BUILD_ENV } = config;

async function submitResetPassword(props, newPassword1, newPassword2) {
  const { token, hash } = props.match.params;
  const url = REACT_APP_BUILD_ENV === 'production' ? 'https://pre-prod.paritygo.com' : 'https://staging.paritygo.com';

  const response = await resetPassword(REACT_APP_BUILD_ENV, url, newPassword1, newPassword2, hash, token);
  return response;
}

const ResetPassword = (props) => {
  const [theme, setTheme] = useState('');
  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [showResetPasswordSuccess, setShowResetPasswordSuccess] = useState(false);

  useEffect(() => {
    const getCurrentTheme = () => {
      const currentTheme = localStorage.getItem('theme-name');

      if (currentTheme === 'light') {
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme(currentTheme);
      } else if (currentTheme === 'dark') {
        localStorage.setItem('app-theme', JSON.stringify(darkVars));
        window.less.modifyVars(darkVars);
        setTheme(currentTheme);
      } else {
        localStorage.setItem('theme-name', 'light');
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme('light');
      }
    };

    getCurrentTheme();
  }, []);

  return (
    <div className={`reset-password reset-password-${theme}`}>
      <div className="reset-password-spacer" />
      <div className="reset-password-content">
        <div className="reset-password-card">
          {showResetPasswordSuccess ? (
            <div className="reset-password-card__content">
              {theme === 'light' ? (
                <img className="reset-password-card__logo" src={logoLight} alt="Parity" />
              ) : (
                <img className="reset-password-card__logo" src={logoDark} alt="Parity" />
              )}
              <div className="reset-password-card__title">Your password has been successfully changed!</div>
              <img className="reset-password-card__image" src={resetSuccess} alt="Parity" />
              <div className="reset-password-card__text-wrapper">
                Please sign in again with your new credentials to get access to your buildings again
              </div>
              <Link to="/login" className="reset-password__link">
                Back to sign in
              </Link>
            </div>
          ) : (
            <div className="reset-password-card__content">
              {theme === 'light' ? (
                <img className="reset-password-card__logo" src={logoLight} alt="Parity" />
              ) : (
                <img className="reset-password-card__logo" src={logoDark} alt="Parity" />
              )}
              <div className="reset-password-card__title">Change password</div>
              <Form
                layout="vertical"
                className={`reset-password-card__form app-form-${theme}`}
                onFinish={() => setShowResetPasswordSuccess(submitResetPassword(props, newPassword1, newPassword2))}
              >
                <Form.Item
                  name="password1"
                  label="Enter new password"
                  className="reset-password__input-wrapper"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter a new password',
                    },
                  ]}
                  hasFeedback
                >
                  <Input.Password
                    value={newPassword1}
                    onChange={(e) => setNewPassword1(e.target.value)}
                    size="large"
                    className="reset-password__input"
                  />
                </Form.Item>
                <Form.Item
                  name="password2"
                  label="Confirm password"
                  className="reset-password__input-wrapper"
                  dependencies={['password1']}
                  rules={[
                    {
                      required: true,
                      message: 'Please enter a new password',
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue('password1') === value) {
                          return Promise.resolve();
                        }

                        return Promise.reject('The two passwords that you entered do not match');
                      },
                    }),
                  ]}
                  hasFeedback
                >
                  <Input.Password
                    value={newPassword2}
                    onChange={(e) => setNewPassword2(e.target.value)}
                    size="large"
                    className="reset-password__input"
                  />
                </Form.Item>
                <div className="reset-password__button-wrapper">
                  <Button block htmlType="submit" size="large" className="reset-password__button">
                    <div className="reset-password__button-text">Continue</div>
                  </Button>
                </div>
              </Form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
